/* @flow */

import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import ArrowLeftIconSvg from './icon-arrow-left.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ArrowLeftIconSvg {...validProps} />;
}
SvgComponent.iconName = 'arrowLeftIcon';

export const ArrowLeftIcon = svgIconWrapper(SvgComponent);
